import React from "react";
import { makeStyles, CssBaseline } from "@material-ui/core";
import { Grid, Paper, LoginContent } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      height: "100vh",
      padding: "16px"
    },
    image: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    logo: {
      height: "100%"
    },
    paper: {
      margin: theme.spacing(8, 4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    containerPaper: {
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    avatar: {
      margin: "1em",
      backgroundColor: theme.palette.primary.main
    },
    form: {
      width: "100%",
      // Fix IE 11 issue.
      marginTop: "1em"
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    forgot: {
      textDecoration: "none",
      color: theme.palette.primary.contrastText,
      padding: "20px"
    },
    padding: {
      padding: "20px"
    },
    loginContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

var LoginMobile = function LoginMobile(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    component: "main",
    className: classes.root
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.image
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "30vh"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: props.src,
    className: classes.logo,
    align: "center",
    alt: "logo-sm"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.loginContainer
  }, /*#__PURE__*/React.createElement(LoginContent, {
    login: props.login,
    newPwdRequired: props.newPwdRequired,
    variant: props.variant,
    email: props.email
  })));
};

export { LoginMobile };